'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This jQuery backend for the react-dnd library is a fork of react-dnd-jquery-backend:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * git@bitbucket.org:bibliocommons/biblio-ui-glue.git
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * We forked this library because it was unfinished, unpublished, did not
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * clone dragged elements properly, and was not setup to build properly.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The motiviation for using the jQuery backend instead of the HTML5 backend
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * was to work around a FireFox bug with input elements inside draggable containers:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * https://bugzilla.mozilla.org/show_bug.cgi?id=739071
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


exports.default = createJQueryBackend;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('jquery-ui/ui/core');

require('jquery-ui/ui/widgets/draggable');

require('jquery-ui/ui/widgets/droppable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return { x: left, y: top };
}

var JQueryBackend = function () {
  function JQueryBackend(manager) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, JQueryBackend);

    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();

    this.sourceNodes = {};
    this.hoveredTargets = [];
    this.targetNodes = {};
  }

  _createClass(JQueryBackend, [{
    key: 'setup',
    value: function setup() {
      if (typeof window === 'undefined') {
        return;
      }

      if (this.constructor.isSetUp) {
        throw new Error('Cannot have two jQuery backends at the same time.');
      }

      if (!_jquery2.default) {
        throw new Error('jQuery not found.');
      }

      this.constructor.isSetUp = true;
    }
  }, {
    key: 'teardown',
    value: function teardown() {
      if (typeof window === 'undefined') {
        return;
      }

      this.constructor.isSetUp = false;
    }
  }, {
    key: 'connectDragSource',
    value: function connectDragSource(sourceId, node) {
      var _this = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (node) {
        (0, _jquery2.default)(node).draggable({
          greedy: true,

          helper: function helper(event) {
            var $target = (0, _jquery2.default)(event.currentTarget);
            return $target.clone().width($target.width()).height($target.height());
          },

          appendTo: 'body',

          start: function start(event, ui) {
            if (ui.helper && typeof options.onStart === 'function') {
              options.onStart(event, ui);
            }

            _this.actions.beginDrag([sourceId], {
              clientOffset: getEventClientOffset(event.originalEvent),
              getSourceClientOffset: _this.getSourceClientOffset.bind(_this),
              publishSource: false
            });

            _this.actions.publishDragSource();
          },

          stop: function stop(event, ui) {
            _this.actions.hover(_this.filterTargets(), {
              clientOffset: getEventClientOffset(event.originalEvent)
            });

            if (typeof options.onStop === 'function') {
              options.onStop(event, ui, _this.monitor);
            }

            _this.hoveredTargets = [];

            _this.actions.drop();
            _this.actions.endDrag();
          }
        });

        this.sourceNodes[sourceId] = { node: node };
        return function () {
          delete _this.sourceNodes[sourceId];
        };
      }
    }
  }, {
    key: 'connectDragPreview',
    value: function connectDragPreview() {}
  }, {
    key: 'filterTargets',
    value: function filterTargets() {
      var _this2 = this;

      var maxOrder = Math.max.apply(null, this.hoveredTargets.map(function (t) {
        return _this2.targetNodes[t].options.uiOrder || 0;
      }));

      return this.hoveredTargets.filter(function (t) {
        return maxOrder === 0 || _this2.targetNodes[t].options.uiOrder === maxOrder;
      });
    }
  }, {
    key: 'connectDropTarget',
    value: function connectDropTarget(targetId, node) {
      var _this3 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (node) {
        (0, _jquery2.default)(node).droppable({
          tolerance: 'pointer',

          over: function over(event) {
            _this3.hoveredTargets.push(targetId);
            _this3.actions.hover(_this3.filterTargets(), {
              clientOffset: getEventClientOffset(event.originalEvent)
            });
          },

          out: function out(event) {
            _this3.hoveredTargets = _this3.hoveredTargets.filter(function (t) {
              return t !== targetId;
            });

            _this3.actions.hover(_this3.filterTargets(), {
              clientOffset: getEventClientOffset(event.originalEvent)
            });
          }
        });

        this.targetNodes[targetId] = { node: node, options: options };
        return function () {
          delete _this3.targetNodes[targetId];
        };
      }
    }
  }, {
    key: 'getSourceClientOffset',
    value: function getSourceClientOffset(sourceId) {
      return getNodeClientOffset(this.sourceNodes[sourceId].node);
    }
  }]);

  return JQueryBackend;
}();

function createJQueryBackend() {
  var optionsOrManager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var jQueryBackendFactory = function jQueryBackendFactory(manager) {
    return new JQueryBackend(manager, optionsOrManager);
  };

  if (optionsOrManager.getMonitor) {
    return jQueryBackendFactory(optionsOrManager);
  }

  return jQueryBackendFactory;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/react-dnd-jquery-backend/lib/services/JQueryBackend.service.js
// module id = 1225
// module chunks = 0